var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.36364C14 13.0909 7 18 7 18C7 18 0 13.0909 0 7.36364C2.76642e-08 5.41068 0.737498 3.53771 2.05025 2.15676C3.36301 0.775809 5.14348 0 7 0C8.85652 0 10.637 0.775809 11.9497 2.15676C13.2625 3.53771 14 5.41068 14 7.36364Z",
    fill: "#99A3B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0013 9.81827C8.28997 9.81827 9.33464 8.71933 9.33464 7.36373C9.33464 6.00812 8.28997 4.90918 7.0013 4.90918C5.71264 4.90918 4.66797 6.00812 4.66797 7.36373C4.66797 8.71933 5.71264 9.81827 7.0013 9.81827Z",
    fill: "#F1F5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cc08ed9db09ef2a7fe4ebb9bee566135.svg";
export { ForwardRef as ReactComponent };